import * as React from 'react';
import TextField from '@mui/material/TextField';
import useStyles from './layout/Styles';
import { usePallet } from '../contexts/PalletContext';
import ProposicaoService from '../services/ProposicaoService';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import ptBRLocale from "date-fns/locale/pt-BR";
import { InputAdornment, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

export default function InputDatePicker(
    props: {
        value: string,
        onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
        id: string,
        label: string,
        inputFormat: string,
        defaultValue?: Date,
        startAdornment?: React.ReactNode,
        minDate?: any
        placeholder?: string
    }) {

    const classes = useStyles();
    const { pallet } = usePallet();

    const handleClear = () => {
        props.onChange && props.onChange(null);
    };

    return (
        <LocalizationProvider locale={ptBRLocale} dateAdapter={AdapterDateFns}>
            <MobileDatePicker
                minDate={props?.minDate}
                inputFormat={props.inputFormat}
                label={props.label}
                value={props.value || props.defaultValue}
                onChange={props.onChange}
                renderInput={(params) => <TextField {...params}
                    placeholder={props.placeholder}
                    style={{ width: "100%" }}
                    id={props.id}
                    variant="outlined"
                    InputProps={{
                        classes: {
                            notchedOutline: classes.notchedOutline,
                        },
                        style: {
                            fontFamily: `${pallet.general.fontFamily}`,
                            fontSize: `${pallet.general.size14}`,
                            fontWeight: pallet.general.weight_100,
                        },
                        startAdornment: (
                            <InputAdornment position="start">
                                {props.startAdornment ? props.startAdornment : ""}
                            </InputAdornment>
                        ),
                        endAdornment: props.value !== null ? (
                            <InputAdornment position="end">
                                <IconButton onClick={handleClear} edge="end">
                                    <ClearIcon />
                                </IconButton>
                            </InputAdornment>
                        ) : undefined,
                    }}
                    InputLabelProps={{
                        style: { color: "grey" }
                    }}
                />}
            />
        </LocalizationProvider >
    );
}
